<template>
  <v-row>
    <v-col cols="4" v-if="showForm">
      <v-row>
        <v-col class="text-h5 gray--text">
          Próteses
        </v-col>
      </v-row>

      <ProsthesisForm
        :surgery="surgery"
        :prosthesis="currentProsthesis"
        :refreshProstheses="refreshProsthesesList"
        :disabled="disabled"
      />
    </v-col>

    <v-col>
      <v-row v-if="!lodash.isEmpty(prostheses)">
        <v-col class="text-h5 gray--text">
          Próteses implantadas
        </v-col>
      </v-row>

      <ProsthesisItem
        v-for="prosthesis in prostheses"
        :key="prosthesis.id"
        :surgery="surgery"
        :intraoperativeProsthesis="prosthesis"
        :editProsthesis="editProsthesis"
        :refreshProstheses="refreshProsthesesList"
        :allowDelete="allowDelete"
        :allowEdit="allowEdit"
        :disabled="disabled"
      />
    </v-col>
  </v-row>
</template>

<script>
  import ProsthesisForm from "@/components/surgery/intraoperative/prosthesis/form.vue";
  import ProsthesisItem from "@/components/surgery/intraoperative/prosthesis/list/item.vue";

  export default {
    name: "ProsthesisList",
    props: {
      surgery: Object,
      refreshProstheses: {
        type: Function,
        default: () => {},
      },
      showForm: {
        type: Boolean,
        default: true,
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
      allowEdit: {
        type: Boolean,
        default: true,
      },
      onlyChosen: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      ProsthesisForm,
      ProsthesisItem,
    },
    data() {
      return {
        currentProsthesis: null,
      };
    },
    computed: {
      prostheses() {
        return this.surgery.intraoperative.prostheses;
      },
    },
    methods: {
      editProsthesis(prosthesis) {
        this.currentProsthesis = prosthesis;
      },
      refreshProsthesesList() {
        this.currentProsthesis = null;
        this.refreshProstheses();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
